<template>

<div 
    :style="{ height: '100%' }"
    class="grid-y grid-frame provider-detail typography"
    :ref="'provider-detail-' + provider.id">
    <div 
      class="cell auto medium-cell-block-container modal-content"
      style="overflow:hidden auto;"
      v-scroll="onScroll">
      <div class="grid-x grid-padding-x" style="margin-top:1rem">
        <div class="cell small-12 medium-4">
          <div style="padding: 1rem">
            <img 
              v-if="provider.image_url" 
              :src="provider.image_url" 
              :id="'img-' + provider.id"
              class="square rounded">
          </div>
        </div>
        <div class="cell small-12 medium-8">
          <h3>{{ provider.formatted_name }}</h3>
          <h5>{{ provider.specialties | implode }}</h5>
          <hr>
          <h6>Populations served: {{ provider.populations | implode }}</h6>
          <div 
            v-if="provider.board_certifications">
            <h6>Board certifications:</h6>
            <p>
              <span v-for="(item, index) in provider.board_certifications" :key="index">
                {{ item.title }}<br>
              </span>
            </p>
            <hr>
          </div>

          <div 
            v-if="provider.education">
            <h6>Education:</h6>
            <education 
              v-for="(item, index) in provider.education" 
              :key="index"
              :item="item">
            </education>
            <hr>
          </div>

          <div 
            v-if="provider.locations">
            <h6>Locations:</h6>
            <locations :locations="provider.locations"></locations>
            <hr>
          </div>

          <div 
            v-if="provider.linked_pages">
            <h6>See also:</h6>
            <linked-pages :pages="provider.linked_pages"></linked-pages>
          </div>
        </div>
      </div>
    </div>
    <div class="cell shrink modal-bottom-bar small-text-center medium-text-right">
      <a class="btn btn-large no-margin" @click="$modal.hideAll()">Close</a>
    </div>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import Education from './Education.vue'
import LinkedPages from './LinkedPages.vue'
import Locations from './Locations.vue'

export default {
  name: 'ProviderDetail',
  components: {
    Education, LinkedPages, Locations
  },
  props: {
    provider: {
      type: Object,
      required: true
    },
    height: {
      type: Number
    }
  },
  data () {
    return {
      stick: false
    }
  },
  filters: {
    implode (val) {
      // Get item titles as a string
      let titles = _.pluck(val, 'title')
      if (titles) {
        return titles.join(', ')
      }
      return ''
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide('modal-provider-detail-' + this.provider.id)
    },
    /** 
     * Load more providers on scroll to bottom
     */
    onScroll (e, pos) {
      if (this.isStickable) {
        if (pos.scrollTop > 5) {
          this.stick = true
        }

        if (pos.scrollTop == 0) {
          this.stick = false
        }
      }
    }
  },
  computed: {
    elem () {
      let elem = this.$refs['provider-detail-' + this.provider.id]
      return (elem ? elem : false)
    },
    styles () {
      return ''
    },
    imgHolderStyles () {
      return 'width: 100%;background-image: url(' + this.item.image_url + ');background-size:100%;background-repeat:no-repeat'
    },
    isStickable () {
      if (this.elem) {
        console.log(this.elem)
        let c = this.elem.querySelector('.modal-content')
        let offset = 0
        console.log(c, c.clientHeight, (this.height + offset))
        if (c && (this.height + offset) > c.clientHeight) {
          return true
        }
      } 
      return false
    },
    boardCertifications () {
      if (this.provider.board_certifications) {
        return this.provider.board_certifications
      }
      return false
    },
    education () {
      if (this.provider.education) {
        return this.provider.education
      }
      return false
    },
    linkedPages () {
      if (this.provider.linked_pages) {
        return this.provider.linked_pages
      }
      return false
    },
    locations () {
      if (this.provider.locations) {
        return this.provider.locations
      }
      return false
    }
  },
  mounted () {
    if (this.elem) {
      this.elem.scrollTo({ top: 0 })
    }
  },
  beforeDestroy () {
    let elem = document.querySelector('body')
    if (elem) {
      elem.classList.remove('no-scroll')
    }
  }
}

</script>
